export class Observable {
  private value: unknown;
  private valueLog: unknown[] = [];
  private observers: Array<(value: unknown) => void> = [];
  constructor(value: unknown) {
    this.value = value;
    this.valueLog.push(value);
  }
  get() {
    return this.value;
  }
  getLogs() {
    return this.valueLog;
  }
  update(value: unknown) {
    this.value = value;
    this.valueLog.push(value);
    this.observers.forEach((observer) => observer(value));
  }
  subscribe(observer: (value: unknown) => void) {
    this.observers.push(observer);
    return observer;
  }
  unsubscribe(observer: (value: unknown) => void) {
    this.observers = this.observers.filter((obs) => obs !== observer);
  }
}
